import { render, staticRenderFns } from "./Donation.vue?vue&type=template&id=1bc05742&scoped=true"
import script from "./Donation.vue?vue&type=script&setup=true&lang=js"
export * from "./Donation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc05742",
  null
  
)

export default component.exports